import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';

const logger = createLogger({ collapsed: true });
const middlewares = [thunkMiddleware];

if (process.env.LOCAL_ENV) middlewares.push(logger);

export default middlewares;
